module.exports = __webpack_public_path__ + "static/media/hit-triple.5c7ea5f8.png";